import React, { useState, useEffect } from "react";
import { Button, Box, Typography } from "@mui/material";

const QuantityEditor = ({
  editIndex,
  quantity,
  index,
  newQuantity,
  handleIncrement,
  handleEditQuantity,
  handleDecrement,
  handleSaveQuantity,
}) => {
  const [isEditing, setIsEditing] = useState(false);  

  useEffect(() => {
    let timer;
    if (isEditing) {
      timer = setTimeout(() => {
        handleSaveQuantity(index);
        setIsEditing(false);
      }, 2000);
    }
    return () => clearTimeout(timer);
  }, [isEditing, index, handleSaveQuantity]);

  const handleAddClick = () => {
    setIsEditing(true);
    handleEditQuantity(index);
  };

  const buttonWidth = isEditing ? "120px" : "60px"; // Adjust widths as needed

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 1 }}>
      <Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: isEditing ? "space-between" : "center",
    transition: "width 0.5s ease",
    width: buttonWidth,
    overflow: "hidden",
    backgroundColor: "primary.main",
    borderRadius: "20px",
    height: "32px", // Consistent height
  }}
>
  {isEditing ? (
    <>
      {/* "-" Button on the Left */}
      <Button
        onClick={(e) => {
          e.stopPropagation();
          handleDecrement();
        }}
        sx={{
          minWidth: "32px",
          height: "32px",
          fontSize: "1rem",
          color: "white",
          backgroundColor: "transparent",
          padding: 0,
          border: "none", // Remove borders
          outline: "none", // Remove outlines
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.1)",
          },
          "&:active": {
            boxShadow: "none",
          },
        }}
      >
        -
      </Button>

      {/* Quantity in the Center */}
      <Typography
        variant="body1"
        sx={{
          width: "32px",
          height: "32px",
          fontWeight: 500,
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: 0,
          padding: 0,
          lineHeight: 1,
        }}
      >
        {newQuantity}
      </Typography>

      {/* "+" Button on the Right */}
      <Button
        onClick={(e) => {
          e.stopPropagation();
          handleIncrement();
        }}
        sx={{
          minWidth: "32px",
          height: "32px",
          fontSize: "1rem",
          color: "white",
          backgroundColor: "transparent",
          padding: 0,
          border: "none", // Remove borders
          outline: "none", // Remove outlines
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.1)",
          },
          "&:active": {
            boxShadow: "none",
          },
        }}
      >
        +
      </Button>
    </>
  ) : (
    // "+ Add" Button
    <Button
    onClick={(e) => {
      e.stopPropagation();
      handleAddClick();
    }}
      sx={{
        width: "100%",
        fontSize: "0.8rem",
        fontWeight: "bold",
        textTransform: "capitalize",
        fontFamily: "Arial",
        color: "white",
        backgroundColor: "transparent",
        border: "none", // Remove borders
        outline: "none", // Remove outlines
        padding: 0, // Ensure no extra padding
        display: "flex",
        alignItems: "center",
        justifyContent: "center", // Center the text
        "&:hover": {
          backgroundColor: "rgba(255,255,255,0.1)",
        },
        "&:active": {
          boxShadow: "none",
        },
      }}
    >
      {quantity ? quantity : "+ Add"}
    </Button>
  )}
</Box>
    </Box>
  );
};

export default QuantityEditor;